import { combineReducers } from 'redux';
import auth from 'UnisportFC/store/reducers/authReducers.js';
import app from '../appReducer';
import general from '../generalReducer';
import overlayFull from './overlayFull/overlayReducer';
import sizes from './sizes/sizeReducer';
import packages from './sizes/packages/packagesReducer';
import tabs from './detailTabs/tabReducer';
import gallery from './gallerySlider/galleryReducer';
import offers from './offers/offersReducer';
import countdown from './countdown/countdownReducer';
import usp from './usp/uspReducer';
import reminder from './sizes/reminderReducer';
import cart from './addToCart/cartReducer';
import uniid from './uniid/uniidReducer';
import tracking from '../trackingReducer';
import popup from '../../Popup/reducer';
import colorway from './colorways/reducer';

export default combineReducers({
  auth,
  general,
  app,
  overlayFull,
  sizes,
  packages,
  tabs,
  gallery,
  offers,
  countdown,
  usp,
  reminder,
  uniid,
  cart,
  tracking,
  popup,
  colorway,
});
